import React, { useEffect, useState } from 'react';
import IconAdd from '../../images/IconAdd.jsx';
import ProjectMilestoneReportAddEdit from './ProjectMilestoneReportAddEdit.jsx';
import ProjectMilestoneReportListItem from './ProjectMilestoneReportListItem.jsx';

const ProjectMilestoneReport = ({ type, isEditMode, initialData, itemsState, setItemsState }) => {
    const [addVisible, setAddVisible] = useState(false);

    useEffect(() => {
        if (isEditMode && initialData?.length > 0) {
            setItemsState(initialData);
        }
    }, [isEditMode, initialData, setItemsState]);

    const handleAddOverlay = () => {
        setAddVisible(true);
    };

    const handleSave = (item) => {
        setItemsState((prev) => [...prev, item]);
    };

    const handleDelete = (id) => {
        setItemsState((prev) => prev.filter((item) => item.id !== id));
    };

    const handleEdit = (id, updatedItem) => {
        setItemsState((prev) => prev.map((item) => (item.id === id ? updatedItem : item)));
    };

    return (
        <>
            <div className='mb-10'>
                <div className='flex justify-between items-center pb-2 mb-2 border-b border-solid border-theme1-tanTransparent'>
                    <div className='text-theme1-primary2 font-bold text-base'>
                        {type.toLowerCase() === 'milestones' ? 'Milestone' : 'Progress Reports'}
                    </div>
                    <button
                        type='button'
                        className='flex items-center justify-center bg-none'
                        onClick={handleAddOverlay}
                    >
                        <IconAdd className='fill-theme1-title2 w-6 h-6' />
                    </button>
                </div>
                {itemsState.map((item) => (
                    <ProjectMilestoneReportListItem
                        key={item.id}
                        data={item}
                        entityType={type}
                        onDelete={handleDelete}
                        onEdit={handleEdit}
                    />
                ))}
            </div>
            {addVisible && (
                <MemoizedProjectMilestoneReportAddEdit
                    addVisible={addVisible}
                    setAddVisible={setAddVisible}
                    onSave={handleSave}
                    type={type}
                />
            )}
        </>
    );
};

const MemoizedProjectMilestoneReportAddEdit = React.memo(ProjectMilestoneReportAddEdit);

export default ProjectMilestoneReport;
